
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/picture-dictionaries/[activitySlug]",
      function () {
        return require("private-next-pages/picture-dictionaries/[activitySlug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/picture-dictionaries/[activitySlug]"])
      });
    }
  